import React from "react";

const imageHeader = require("assets/img/brand/golive-2026.png").default;

const containerStyle = {
  width: "210mm",
  minHeight: "297mm",
  padding: "20mm",
  fontFamily: "Times New Roman",
  fontSize: "12pt",
  backgroundColor: "white",
  color: "black",
  boxSizing: "border-box",
  pageBreakAfter: "always",
  border: "1px solid #ccc",
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "10px",
};

const thTdStyle = {
  border: "1px solid black",
  padding: "6px",
  textAlign: "left",
};

const titleStyle = {
  textAlign: "center",
  fontSize: "18pt",
  fontWeight: "bold",
};

const projectHeaderStyle = {
  backgroundColor: "black",
  color: "white",
  fontWeight: "bold",
  padding: "6px 10px",
  marginTop: "20px",
  fontSize: "11pt",
};

const totalRowStyle = {
  backgroundColor: "red",
  color: "white",
  fontWeight: "bold",
  textAlign: "center",
};

const totalCellStyle = {
  ...thTdStyle,
  ...totalRowStyle,
  fontSize: "14pt",
  fontWeight: "bold",
  textAlign: "center",
};

function formatDate2(dateStr) {
  if (!dateStr) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  }
  if (dateStr.includes("/")) {
    const parts = dateStr.split("/").map(Number);
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${String(day).padStart(2, "0")}-${String(month).padStart(2, "0")}-${year}`;
    }
  }
  return "";
}

function formatDate(dateStr) {
  if (!dateStr) return "";
  if (typeof dateStr === "string" && /^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    return dateStr;
  }
  let date;
  if (typeof dateStr === "string" && dateStr.includes("/")) {
    const parts = dateStr.split("/").map(Number);
    if (parts.length === 3) {
      const [day, month, year] = parts;
      date = new Date(year, month - 1, day);
    }
  } else {
    date = new Date(dateStr);
  }
  if (isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

function somarHoras(lista) {
  let totalMin = 0;
  lista.forEach((item) => {
    const [h, m] = item.horas.split(":").map(Number);
    totalMin += h * 60 + m;
  });
  const horas = Math.floor(totalMin / 60);
  const minutos = totalMin % 60;
  return `${String(horas).padStart(2, "0")}:${String(minutos).padStart(2, "0")}`;
}

function calcularTotaisPorChamado(lista) {
  const totais = {};
  lista.forEach((item) => {
    if (!totais[item.numero]) {
      totais[item.numero] = [];
    }
    totais[item.numero].push(item);
  });
  const totaisHoras = {};
  for (const numero in totais) {
    totaisHoras[numero] = somarHoras(totais[numero]);
  }
  return totaisHoras;
}

function PrintableReportChamados({ groupedData, customerName, dateFrom, dateTo }) {
  const projectNames = Object.keys(groupedData || {});

  return (
    <div>
      {projectNames.map((projectName, index) => {
        // Ordena por número do chamado (string ou número)
        const chamados = [...groupedData[projectName]].sort((a, b) =>
          String(a.numero).localeCompare(String(b.numero))
        );

        const totalHorasProjeto = somarHoras(chamados);
        const totaisPorChamado = calcularTotaisPorChamado(chamados);

        return (
          <div key={index} id={`divToPrint-${index}`} style={containerStyle}>
            {/* Cabeçalho */}
            <div style={{ marginBottom: "20px", textAlign: "center" }}>
              <div>
                <img
                  src={imageHeader}
                  alt="Logo"
                  style={{ maxWidth: "130px", maxHeight: "60px" }}
                />
              </div>
              <div style={titleStyle}>Relatório de Chamados</div>
              <div>
                Referência: De {formatDate2(dateFrom) || "..."} Até {formatDate2(dateTo) || "..."}
              </div>
            </div>

            {/* Cliente e Projeto */}
            <div style={projectHeaderStyle}>
              Cliente: {customerName?.toUpperCase()}
            </div>
            <div style={projectHeaderStyle}>
              Projeto: {projectName?.toUpperCase()}
            </div>

            {/* Tabela */}
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thTdStyle}>Data</th>
                  <th style={thTdStyle}>Nº Chamado</th>
                  <th style={thTdStyle}>Descrição</th>
                  <th style={thTdStyle}>Horas</th>
                  <th style={thTdStyle}>Total do Chamado</th>
                </tr>
              </thead>
              <tbody>
                {chamados.map((chamado, i) => {
                  const isUltimaLinhaDoChamado =
                    i === chamados.length - 1 || chamados[i + 1].numero !== chamado.numero;

                  return (
                    <tr key={i}>
                      <td style={thTdStyle}>{formatDate(chamado.date)}</td>
                      <td style={thTdStyle}>{chamado.numero}</td>
                      <td style={thTdStyle}>{chamado.descricao}</td>
                      <td style={thTdStyle}>{chamado.horas}</td>
                      <td style={thTdStyle}>
                        {isUltimaLinhaDoChamado ? totaisPorChamado[chamado.numero] : ""}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={4} style={totalCellStyle}>
                    TOTAL DO {projectName?.toUpperCase()}:
                  </td>
                  <td style={totalCellStyle}>{totalHorasProjeto}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

export default PrintableReportChamados;
